var map = {
	"./account/template": 31245,
	"./billings/tasks/template": 36301,
	"./billings/template": 33054,
	"./companies/template": 17769,
	"./contacts/template": 75921,
	"./contracts/template": 60761,
	"./credentials/template": 59766,
	"./dictionaries/template": 97654,
	"./documentation/template": 45834,
	"./eventsHistory/template": 27157,
	"./files/template": 95145,
	"./inactiveProviders/template": 42015,
	"./invoices/template": 82841,
	"./keywordLists/template": 79878,
	"./login/template": 96171,
	"./messageRuleGroups/template": 25095,
	"./messageRules/template": 63468,
	"./notifications/dialog/template": 51165,
	"./notifications/settingsSite/template": 13251,
	"./notifications/settingsUser/template": 71227,
	"./notifications/template": 37964,
	"./operatorGroups/template": 63830,
	"./otp-settings/channels/template": 79386,
	"./otp-settings/templates/template": 78921,
	"./otp-settings/widgets/template": 50367,
	"./patterns/template": 72867,
	"./pay/template": 82430,
	"./paymentLogs/template": 12159,
	"./payments/template": 63935,
	"./permissions/template": 43780,
	"./providerGroups/template": 91553,
	"./providers/template": 59902,
	"./recover/template": 51448,
	"./referrals/template": 89170,
	"./registration/template": 53317,
	"./requisites/template": 72626,
	"./routingGroups/template": 74990,
	"./routingRules/template": 74417,
	"./sendernames/template": 90049,
	"./sendings/incoming/template": 64800,
	"./sendings/tasks/template": 30652,
	"./sendings/template": 24707,
	"./sendingsCreate/template": 90143,
	"./sendingsModeration/template": 56699,
	"./servers/template": 88608,
	"./settings/template": 87157,
	"./settingsSite/template": 16316,
	"./settingsUser/template": 31000,
	"./support/template": 8405,
	"./tariffs/template": 6765,
	"./tasks/template": 26414,
	"./templates/template": 59757,
	"./tokens/template": 83872,
	"./userComments/template": 91233,
	"./users/requisites/template": 49951,
	"./users/template": 74464,
	"./users/tokens/template": 16719,
	"./yclients/template": 71385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22449;